import * as React from 'react';
import { MenuEntry } from '@europrocurement/flexy-components';

import { prescribersListIcon } from '@europrocurement/l2d-icons';
import PrescriberDetail from './views/detail/PrescriberDetail';
import PrescripteursListing from './views/listing/PrescripteursListing';
import PrescripteurAdd from './views/create/PrescripteurCreation';
import PrescipteurRoot from './views/PrescripteurRoot';
import { PRESCRIBER_LIST, prescripteursBasePath, PRESCRIBER_NEW } from './constants/paths';

export const PrescripteurRouter = {
    path: prescripteursBasePath,
    element: <PrescipteurRoot />,
    children: [
        {
            path: 'liste',
            children: [
                {
                    path: '',
                    index: true,
                    element: <PrescripteursListing />,
                },
                {
                    path: ':idPrescripteur',
                    element: <PrescriberDetail />,
                },
            ],
        },
        {
            path: 'new',
            element: <PrescripteurAdd />,
        },
    ],
};

export const PrescripteurMenuEntries: MenuEntry[] = [
    {
        title: 'Prescripteurs',
        icon: 'users',
        role: 'prescripteur',
        children: [
            {
                title: 'Liste des prescripteurs',
                icon: prescribersListIcon,
                href: PRESCRIBER_LIST,
                role: 'prescripteur',
            },
            {
                title: 'Nouveau prescripteur',
                icon: 'user-plus',
                href: PRESCRIBER_NEW,
                role: 'prescripteur',
            },
        ],
    },
];
